// @core/api/endpoints/form/get_entity_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetEntityFormResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Get entity form
 * Returns the form aspect data for any entity with form aspect. Includes form status, submission counts, and configuration.
 */
export async function GetEntityForm(
  target_type: string,
  target_id: string,
  options?: RequestOptions
): Promise<GetEntityFormResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form/:target_type/:target_id`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<GetEntityFormResponse>(requestPath, { ...requestOptions });
}
